import {ReaderService} from "../services/ReaderService";
import {CommandManager} from "../libs/CommandManager";
import {Reader} from "../entities/Reader";
import {QueuedCommand} from "../entities/QueuedCommand";

export class CommandResetNetworkCtrl {
    commandEnabled:boolean = false;
    readers:Reader[];
    selectedReader:Reader;
    static $inject = ['CommandManager','ReaderService'];
    constructor(public commandManager:CommandManager, public readerService:ReaderService) {
        this.readerService.getGateways().then((data)=>{
            this.readers = data;
            if(data.length > 0)
                this.selectedReader = data[0];
        })
    }
    runCommand(){
        var queuedCommand = new QueuedCommand(null,null,"Reset Network",this.selectedReader.name,this.selectedReader.id);
        this.commandManager.runCommands([queuedCommand]);
    }
}


export class CommandResetNetworkDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdresetnetwork.html').default;
    scope = {
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandResetNetworkCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        //let url = controller.getUrl();
        //element.text('Current URL: ' + url);
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandResetNetworkDirective();
        }
        return directive;
    }
}
